require('./emails.component.scss');

export class EmailsController {
  constructor(
    $scope,
    $rootScope,
    $element,
    $timeout,
    $http,
    rx,
    observeOnScope,
    CurrentModelService,
    ErrorHandlerService,
    $cookies,
    PermissionService,
  ) {
    this.$scope = $scope;
    this.$rootScope = $rootScope;
    this.$element = $element;
    this.$timeout = $timeout;
    this.$http = $http;
    this.selectedLang = $cookies.get('django_language') || PermissionService.selectedLang || PermissionService.defaulLang;
    // this.selecter = this.$element.find('select');
    this.rx = rx;
    this.ErrorHandlerService = ErrorHandlerService;
    this.CurrentModelService = CurrentModelService;
    this.filteredSuggestions = [];
    this.suggestions = [];
    this.search = '';
    this.editSearch = '';
    this.prevValue = [];
    this.valueObj = {};
    this.index = 0;
    this.editIndex = -1;
    this.setSize(this.valie);
    this.outClick = event => {
      if (!this.$element[0].contains(event.target)) {
        this.isOptionsOpen = false;
        if (this.search) {
          this.onSearchEnter();
          this.search = '';
        }
        if (this.editIndex > -1) this.editValues();
        if (!this.$rootScope.$$phase) this.$scope.$apply();
      } else if (event.target.tagName == 'I' &&
        event.target.classList.contains('icon-enter')) {
        event.keyCode = 13;
        this.onSearchEnter(event);
      }
    };
    document.addEventListener('click', this.outClick);
    this.subscriptions = [
      rx.Observable.merge(
        observeOnScope($scope, '$ctrl.search'),
      )
      .do(() => {
        this.loading = true;
        this.suggestions = [];
      })
      .debounce(200)
      .switchMap(() => this.getSuggestions(this.search))
      .do(() => {
        this.loading = false;

      })
      .subscribe(
        suggestions => {
          this.suggestions = suggestions.data.object_list;
          this.filterSuggestions();
          $scope.$digest();
        },
        (error) => {
          console.error(error);
          this.loading = false;
          $scope.$digest();
        },
      ),
    ];
    this.error = false;
  }

  $onInit() {
    this.setValueObject();
  }

  $onDestroy() {
    document.removeEventListener('click', this.outClick);
    this.subscriptions.forEach((s) => {
      if (s.dispose) s.dispose();
    });
  }

  $doCheck() {
    if (
      this.filterEmails && this.filterEmails.length > 0
      && JSON.stringify(this.valueObj) === JSON.stringify({})
    ) {
      // set value if we set admin email for test email
      this.setValueObject();
    }
  }

  setSize(length) {
    return this.size = length > 20 ? 20 : (length < 2 ? 2 : length);
  }

  getDropdownValue(cell) {
    if (typeof cell == 'string') {
      return {
        label: cell,
        name: cell
      };
    }
    if (this.fullDimension === 'agent_eventtype@default:agent_eventtype') {
      return {
        label: cell['agent_eventtype.description'],
        name: cell['agent_eventtype.name']
      };
    }
    const [dimName, hier] = this.fullDimension.split('@');
    let dimHier;
    let dimLevel;
    if (hier)[dimHier, dimLevel] = hier.split(':');
    const key = `${dimName}.${dimLevel}`;
    if (key in cell) {
      return {
        label: cell[key],
        name: cell[key]
      };
    } else {
      console.error(cell);
      return {
        label: '',
        name: ''
      };
    }
  }

  getSuggestions(lookup) {
    return this.rx.Observable.fromPromise(
      this.$http.get(`/analytics/users/?search=${lookup}`));
  }

  onSearchFocus() {
    if (this.disabled) return;
    this.isOptionsOpen = true;
  }

  getFaqReportLink() {
    return '/static/staffcop/docs_' + this.selectedLang + '/faq/faq_report.html';
  }

  clickToChoosen() {
    if (this.disabled) return;
    this.editValues();
    this.isOptionsOpen = true;
    this.$timeout(() => this.$element.find('input').focus(), 10);

  }

  isSelectedOption(option) {
    return this.valueObj[option.mail];
  }

  onSearchEnter(e) {
    if (e && e.keyCode != 13) return;
    let isUser = false;
    this.search.split(';').map(s => {
      const user = this.extractUser(s);
      if (!user.mail) return;
      isUser = true;
      this.toggleValue(user, false);
    });
    if (this.hasfilteredSuggestions && this.search) {
      this.toggleValue(this.filteredSuggestions[0], false);
    }
    this.search = '';
  }

  editValues() {
    if (this.disabled) return;
    if (this.editIndex < 0) return;
    const user = this.extractUser(this.editSearch);

    if (!user.mail) {
      this.validationError = this.editIndex;
      return;
    }
    this.validationError = -1;
    user.index = this.editIndex;
    const oldUser = this.values.find(u => u.index == this.editIndex);
    if (oldUser) delete this.valueObj[oldUser.mail];
    this.valueObj[user.mail] = user;
    this.values = this.getValues();
    this.editIndex = -1;
  }

  onEditSearchEnter(e) {
    if (e && e.keyCode != 13) return;
    this.editValues();
  }

  getSearchWidth(str) {
    const maxWidth = this.$element.width() - 40;
    const strWidth = (str.length || 1) * 8.43;
    return maxWidth > strWidth ? `${strWidth}px` : `${maxWidth}px`;
  }

  getValues() {
    const values = Object.keys(this.valueObj).map(key => this.valueObj[key]).sort((a, b) => a.index - b.index);
    this.filterEmails = values.map(user => `"${user.user_name.trim()}"<${user.mail}>`).join('\n');
    return values;
  }

  setToEdit(value) {
    this.editValues();
    this.editSearch = this.emailToFullStr(value);
    this.editIndex = value.index;
    this.isOptionsOpen = false;
    this.search = '';
  }

  toggleValue(value, needDelete) {
    if (this.disabled) return;
    if (!value || !value.mail) return;
    if (!this.valueObj) this.setValueObject();
    if (this.valueObj[value.mail]) {
      if (needDelete) delete this.valueObj[value.mail];
    } else {
      this.valueObj[value.mail] = {
        mail: value.mail,
        user_name: this.emailToStr(value),
        index: ++this.index
      };
    }
    this.values = this.getValues();
    this.search = '';
    // this.setValueObject();
    this.$scope.$emit('searchChange');

  }

  extractUser(str) {
    const extractName = name => {
      const reName = /\"(.*?)\"/;
      const resName = reName.exec(name);
      if (resName && resName.length > 1) return resName[1].trim();
      return name.trim();
    };

    const validateEmail = mail => {
      if (mail.match(
          /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
        )) return true;
      if (mail.match(/^@[A-Za-z\d_]{5,32}$/)) return true;
      return false;
    };

    const user = {};
    let re = /\<(.*?)\>/;
    let res = re.exec(str);
    let mail = '';
    if (!res) {
      re = /\((.*?)\)/;
      res = re.exec(str);
    }
    if (res && res.length > 1) {
      mail = res[1].trim();
      if (validateEmail(mail)) {
        user.mail = mail;
        user.user_name = extractName(str.substr(0, res.index));
        return user;
      }
      str = str.substr(0, res.index);
    }
    const strArray = str.split(' ');
    for (const i in strArray) {
      if (validateEmail(strArray[i])) {
        user.mail = strArray[i];
        if (strArray.length > 1) {
          strArray.splice(i, 1);
          user.user_name = strArray.filter(s => s).join(' ');
        } else user.user_name = user.mail;
        return user;
      }
    }
    return {};
  }

  setValueObject() {
    this.valueObj = this.filterEmails ? this.filterEmails.split('\n').reduce((res, v, i) => {
      const user = this.extractUser(v);
      if (user.mail) {
        this.index = i;
        user.index = i;
        res[user.mail] = user;
      }
      return res;
    }, {}) : {};
    this.values = this.getValues();
  }


  get hasfilteredSuggestions() {
    return this.filteredSuggestions.length > 0;
  }

  filterSuggestions() {
    if (!(typeof this.search == 'string')) return;
    if (!this.search) {
      this.filteredSuggestions = this.suggestions;
    } else {
      const search = this.search.toLowerCase();
      this.filteredSuggestions = this.suggestions.filter(suggestion =>
        (suggestion.mail.toLowerCase().includes(search) ||
          suggestion.user_name.toLowerCase().includes(search) ||
          suggestion.full_name.toLowerCase().includes(search)
        ) && !this.valueObj[suggestion.mail]);
    }
    this.$scope.$emit('searchChange');
  }

  emailToStr(user) {
    if (user.full_name) return user.full_name;
    if (user.user_name) return user.user_name;
    return user.mail;
  }

  emailToFullStr(user) {
    if (user.full_name) return `${user.full_name} <${user.mail}>`;
    if (user.user_name) return `${user.user_name} <${user.mail}>`;
    return user.mail;
  }
}


export const EmailsComponent = {
  bindings: {
    filterEmails: '=',
    disabled: '@',
  },
  template: require('./emails.component.html'),
  controller: EmailsController,
};



// WEBPACK FOOTER //
// ./src/filter/editor/emails/emails.component.js